import React, { useState } from 'react';
// import TicketPerf from '../../../assets/order/ticket-perf.svg';
// import MobileTicket from '../../../assets/order/mobile-ticket.svg';
// import QR from '../../../assets/order/qr.svg';
import { QrIcon } from '../icons/QrIcon';
import { TicketClaimedIcon } from '../icons/TicketClaimedIcon';
import { SoldIcon } from '../icons/SoldIcon';
import { NotClaimedIcon } from '../icons/NotClaimedIcon';
import { AvailableTicket, ClaimableTicket, TicketStatus, Ticket as TicketType, TicketType as TicketTypeEnum, SoldTicket, ForSaleTicket } from '@/lib/OrderApi';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../shared/Dialog';
import ScanOrDownloadTicketModal from './ScanOrDownloadTicketModal';
// import clsx from 'clsx';
import { RiCashLine, RiLock2Fill, RiShare2Line, RiStore2Line, RiInformationLine, RiForbid2Line, RiHeartLine, RiWalletLine } from '@remixicon/react';
import { Money } from '@/lib/money';
import SealedTicketModal from './SealedTicketModal';
import { MoneyValues } from '@/lib/TicketApi';
import SelfClaimTicketModal from './SelfClaimTicketModal';
import ShareTicketModal from './shareTicketModal';
// import { ShareTicketWithoutPersonalisationButton } from './ShareTicketButton';
import ListTicketModal from './listTicketModal';
import { ShareTicketWithoutPersonalisationButton } from './ShareTicketButton';
import SoldDetailsModal from './SoldDetailsModal';
import QRCode from 'react-qr-code';

// Define a type for sold tickets that might include details needed for the modal
type SoldTicketWithDetails = SoldTicket & Partial<Pick<ForSaleTicket, 'listingPriceExFee' | 'resaleFeeAmountSeller'>> & { 
    sellerReceivable?: MoneyValues 
};

interface TicketProps {
  orderId: string;
  ticket: TicketType;
  answers: Record<string, object[] | string[]>;
  triggeredReload: () => void;
  marketplaceUrl: string|null;
  isSubTicket?: boolean;
}

import { useLanguage } from '@/providers/LanguageProvider';
import * as m from "@/paraglide/messages.js"

const Ticket: React.FC<TicketProps> = ({orderId, ticket, answers, triggeredReload, marketplaceUrl, isSubTicket }) => {

  const { currentLanguage: lang } = useLanguage();
  
  const [ticketScanModalOpen, setTicketScanModalOpen] = useState(false);
  const [selfClaimTicketModalOpen, setSelfClaimTicketModalOpen] = useState(false);
  const [shareTicketModalOpen, setShareTicketModalOpen] = useState(false);
  const [listTicketModalOpen, setListTicketModalOpen] = useState(false);
  const [soldDetailsModalOpen, setSoldDetailsModalOpen] = useState(false);
  const [cashCardModalOpen, setCashCardModalOpen] = useState(false);
  
  function availableTicket(ticket: AvailableTicket): React.ReactNode {
    // CashCard: show wallet icon
    if (ticket.ticketType === TicketTypeEnum.CashCard) {
      return (
        <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => setCashCardModalOpen(true)}>
          <RiWalletLine className='h-12 py-2'/>
          <span className='text-sm text-center tracking-tight'>Cash Card</span>
        </button>
      );
    }
    // Check if the ticket is an EntranceTicket and is used
    if (ticket.ticketType === TicketTypeEnum.EntranceTicket && ticket.noMoreValidEntrances) {
      return <button className='cursor-pointer flex flex-col items-center opacity-50' onClick={() => {
        setTicketScanModalOpen(true);
      }}>
        <QrIcon className='h-12 py-2'/>
        <span className='text-sm text-center tracking-tight'>Used</span>
      </button>
    }

    // Only check for sealed property if it's an EntranceTicket
    if (ticket.ticketType === TicketTypeEnum.EntranceTicket && ticket.sealed) {
      return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
        setTicketScanModalOpen(true);
      }}>
        <RiLock2Fill className='h-12 py-2'/>
        <span className='text-sm text-center tracking-tight'>Sealed ticket</span>
      </button>
    }
    return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
      setTicketScanModalOpen(true);
    }}>
      <QrIcon className='h-12 py-2'/>
      <span className='text-sm text-center tracking-tight'>{m.order_ticket_show_ticket()}</span>
    </button>
  }

  function donationTicketIcon(): React.ReactNode {
    // Only for DonationTicket
    return (
      <div className="flex flex-col items-center justify-center">
        <RiHeartLine className="h-12 w-12 py-2 text-pink-500" style={{ color: 'var(--shop-ctaButtonColor)' }} />
        <span className="text-sm text-center tracking-tight">Donation</span>
      </div>
    );
  }

  function renderTicketStatusIcon(ticket: TicketType): React.ReactNode | Iterable<React.ReactNode> {
    switch(ticket.ticketStatus) {
      case TicketStatus.available:
        // Ensure it's not GroupedTicket
        if (ticket.ticketType === TicketTypeEnum.GroupedTicket) return null;
        if (ticket.ticketType === TicketTypeEnum.DonationTicket) return donationTicketIcon();
        // CashCard: show wallet icon
        if (ticket.ticketType === TicketTypeEnum.CashCard) {
          return availableTicket(ticket);
        }
        // Now it must be AvailableTicket
        return availableTicket(ticket);
      case TicketStatus.forSale:
        return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
          setListTicketModalOpen(true);
        }}>
          <RiStore2Line size={40} className='h-10 py-1'/>
          <span className='text-sm text-center tracking-tight'>For sale on marketplace</span>
        </button>
      // case TicketStatus.sealed:
        // return <img src={MobileTicket} alt="" className='h-12 py-1'/>
      case TicketStatus.claimable:
        // Ensure it's not GroupedTicket
        if (ticket.ticketType === TicketTypeEnum.GroupedTicket) {
          return null;
        }
        // Now it must be ClaimableTicket
        {
          // Scope the declaration within braces
          const claimableTicket = ticket as ClaimableTicket; 
          if(claimableTicket.isSelfClaimable) { 
            return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
              setSelfClaimTicketModalOpen(true);
            }}>
              <NotClaimedIcon className='h-10 py-1'/>
              <span className='text-sm text-center tracking-tight'>Claim ticket</span>
            </button>
          } else {
            return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
              setShareTicketModalOpen(true);
            }}>
              <RiShare2Line size={40} className='h-10 py-1'/>
              <span className='text-sm text-center tracking-tight'>share ticket</span>
            </button>
          }
        }
      case TicketStatus.shared:
        return <button className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all' onClick={() => {
          setShareTicketModalOpen(true);
        }}>
          <RiShare2Line size={40} className='h-10 py-1'/>
          <span className='text-sm text-center tracking-tight'>share ticket (pending)</span>
        </button>
      case TicketStatus.claimed:
        return <div className='flex flex-col items-center'>
          <TicketClaimedIcon className='h-10 py-1'/>
          {ticket.claimedBy && <span className='text-sm text-center tracking-tight'>Claimed by {ticket.claimedBy}</span>}
        </div>

      case TicketStatus.sold: {
        // For sub-tickets, show a non-clickable icon+text only
        if (isSubTicket) {
          return (
            <div className='flex flex-col items-center opacity-70'>
              <SoldIcon className='h-10 py-1'/>
              <span className='text-sm text-center tracking-tight'>Sold on marketplace</span>
            </div>
          );
        }

        // For regular tickets, show the clickable button with details
        const soldTicketDetails = ticket as SoldTicketWithDetails;
        return (
          <button 
            className='cursor-pointer flex flex-col items-center hover:scale-105 transition-all'
            onClick={() => setSoldDetailsModalOpen(true)} 
          >
            <SoldIcon className='h-10 py-1'/>
            <span className='text-sm text-center tracking-tight'>Sold on marketplace</span>
            {/* Check existence before accessing */}
            {soldTicketDetails.sellerReceivable && (
              <span className='text-xs font-semibold text-center tracking-tight mt-1'>
                ({Money.fromInteger(soldTicketDetails.sellerReceivable.amount, soldTicketDetails.sellerReceivable.currency).display(lang)})
              </span>
            )}
          </button>
        );
      }
      case TicketStatus.blocked:
        return <div className='flex flex-col items-center opacity-50'>
          <RiForbid2Line size={40} className='h-10 py-1'/>
          <span className='text-sm text-center tracking-tight'>Blocked</span>
        </div>
    }

    // Mobile ticket
    // <img src={MobileTicket} alt="" className='h-12 py-1'/>
    // <span className='text-sm text-center tracking-tight'>Activate mobile ticket</span>
  }

  return (
    <div className="mt-4">
      <div className="flex h-[100px]">
        {/* Left Icon Section */}
        <div className={`bg-[var(--shop-panelBackgroundColor)] text-[var(--shop-textColor)] w-[100px] flex flex-col items-center justify-center p-2 rounded-md rounded-tr-none rounded-br-none`}>
          {/* --- DEBUG LOGS START --- */}
          {(() => {
            console.log('[Ticket Render] Sub-Ticket Object:', JSON.parse(JSON.stringify(ticket))); // Log the whole sub-ticket
            console.log('[Ticket Render] Sub-Ticket Status:', ticket.ticketStatus); // Log status
            if ('ticketType' in ticket) {
              console.log('[Ticket Render] Sub-Ticket Type:', ticket.ticketType); // Log type if exists
              console.log('[Ticket Render] Condition Check (ticketType !== GroupedTicket):', ticket.ticketType !== TicketTypeEnum.GroupedTicket);
            } else {
              console.log('[Ticket Render] Sub-Ticket Type: Not present');
            }
            console.log('[Ticket Render] Calling renderTicketStatusIcon?:', 'ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket);
            return null; // This IIFE is just for logging
          })()}
          {/* --- DEBUG LOGS END --- */}

          {/* Render icon only if not a GroupedTicket */}
          {('ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket) && renderTicketStatusIcon(ticket)}
        </div>
        {/* Divider SVG */}
        <svg width="10" height="100" viewBox="0 0 10 100" fill="none" xmlns="http://www.w3.org/2000/svg" className='h-[100px]'>
          <path fillRule="evenodd" clipRule="evenodd" d="M9.03223 100H8.89146C8.89146 97.5567 6.91399 95.576 4.47473 95.576C2.03548 95.576 0.0579977 97.5567 0.0579977 100H-0.000199318V0H0.0579977C0.0579977 2.44331 2.03548 4.42406 4.47473 4.42407C6.91399 4.42407 8.89146 2.44331 8.89146 0L9.03223 6.82303e-09V100ZM1.9747 86.8422C1.9747 85.4593 3.09405 84.3381 4.47473 84.3381C5.85541 84.3381 6.97476 85.4593 6.97476 86.8422C6.97476 88.2253 5.85541 89.3465 4.47473 89.3465C3.09405 89.3465 1.9747 88.2253 1.9747 86.8422ZM4.47473 75.5426C3.09405 75.5426 1.9747 76.6637 1.9747 78.0468C1.9747 79.4298 3.09405 80.551 4.47473 80.551C5.85541 80.551 6.97476 79.4298 6.97476 78.0468C6.97476 76.6637 5.85541 75.5426 4.47473 75.5426ZM1.9747 68.6978C1.9747 67.3148 3.09405 66.1937 4.47473 66.1937C5.85541 66.1937 6.97476 67.3148 6.97476 68.6978C6.97476 70.0809 5.85541 71.202 4.47473 71.202C3.09405 71.202 1.9747 70.0809 1.9747 68.6978ZM4.47473 56.8447C3.09405 56.8447 1.9747 57.966 1.9747 59.3489C1.9747 60.732 3.09405 61.8531 4.47473 61.8531C5.85541 61.8531 6.97476 60.732 6.97476 59.3489C6.97476 57.966 5.85541 56.8447 4.47473 56.8447ZM1.9747 50.0001C1.9747 48.617 3.09405 47.4959 4.47473 47.4959C5.85541 47.4959 6.97476 48.617 6.97476 50.0001C6.97476 51.383 5.85541 52.5041 4.47473 52.5041C3.09405 52.5041 1.9747 51.383 1.9747 50.0001ZM4.47473 38.1469C3.09405 38.1469 1.9747 39.2681 1.9747 40.6511C1.9747 42.0342 3.09405 43.1553 4.47473 43.1553C5.85541 43.1553 6.97476 42.0342 6.97476 40.6511C6.97476 39.2681 5.85541 38.1469 4.47473 38.1469ZM1.9747 31.3022C1.9747 29.9191 3.09405 28.798 4.47473 28.798C5.85541 28.798 6.97476 29.9191 6.97476 31.3022C6.97476 32.6852 5.85541 33.8064 4.47473 33.8064C3.09405 33.8064 1.9747 32.6852 1.9747 31.3022ZM4.47473 19.4492C3.09405 19.4492 1.9747 20.5703 1.9747 21.9532C1.9747 23.3363 3.09405 24.4574 4.47473 24.4574C5.85541 24.4574 6.97476 23.3363 6.97476 21.9532C6.97476 20.5703 5.85541 19.4492 4.47473 19.4492ZM1.9747 12.6044C1.9747 11.2213 3.09405 10.1002 4.47473 10.1002C5.85541 10.1002 6.97476 11.2213 6.97476 12.6044C6.97476 13.9873 5.85541 15.1085 4.47473 15.1085C3.09405 15.1085 1.9747 13.9873 1.9747 12.6044Z" fill="var(--shop-panelBackgroundColor)"/>
        </svg>
        {/* Right Content Section */}
        <div className={`bg-[var(--shop-panelBackgroundColor)] text-[var(--shop-textColor)] grow -ml-[0.8px] flex flex-col justify-between rounded-md rounded-tl-none rounded-bl-none`}>
          {/* Top Row: Name & Modals */}
          <div className='flex px-4 items-center justify-between border-[var(--shop-borderColor)] border-b grow'>
            <div className='flex items-center'>
              <span className='text-sm leading-normal font-semibold'>{ticket.productName}</span> <span className='ml-1 text-xs tracking-tight'> {ticket.selfClaimed ?? false ? 'Your ticket' : `${ticket.numberOfProductType}/${ticket.totalOfProductType}`}</span>
            </div>
            {/* --- Modals --- */}
            {('ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.DonationTicket) && (
              <>
                <Dialog open={ticketScanModalOpen} onOpenChange={setTicketScanModalOpen}>
                  {('ticketType' in ticket && ticket.ticketType === TicketTypeEnum.EntranceTicket && 
                    'sealed' in ticket && ticket.sealed && 
                    'availableFrom' in ticket && ticket.availableFrom) ? (
                    <SealedTicketModal availableFrom={ticket.availableFrom} />
                  ) : (
                    // Ensure we don't pass GroupedTicket to ScanOrDownload
                    'ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && <ScanOrDownloadTicketModal ticket={ticket} />
                  )}
                </Dialog>
                <Dialog open={selfClaimTicketModalOpen} onOpenChange={setSelfClaimTicketModalOpen}>
                  {/* Ensure we don't pass GroupedTicket to SelfClaim */}
                  {'ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && <SelfClaimTicketModal ticket={ticket} answers={answers} onSuccess={() => {
                    triggeredReload();
                    setSelfClaimTicketModalOpen(false);
                  }} orderId={orderId}/>} 
                </Dialog>
                <Dialog open={shareTicketModalOpen} onOpenChange={setShareTicketModalOpen}>
                  {/* Ensure we don't pass GroupedTicket to Share */}
                  {'ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && <ShareTicketModal ticket={ticket} onSuccess={() => {
                    triggeredReload();
                  }} orderId={orderId}/>} 
                </Dialog>
                <Dialog open={listTicketModalOpen} onOpenChange={setListTicketModalOpen}>
                  {/* Ensure we don't pass GroupedTicket to List */}
                  {'ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && <ListTicketModal ticket={ticket} 
                  marketplaceUrl={marketplaceUrl}
                  onSuccess={() => {
                    triggeredReload();
                    setListTicketModalOpen(false);
                  }} orderId={orderId}/>} 
                </Dialog>
                {/* Use the extracted SoldDetailsModal component */}
                <SoldDetailsModal 
                  isOpen={soldDetailsModalOpen} 
                  onClose={() => setSoldDetailsModalOpen(false)} 
                  ticket={ticket.ticketStatus === TicketStatus.sold ? ticket as SoldTicketWithDetails : null} 
                />
                {/* CashCard Modal */}
                {'ticketType' in ticket && ticket.ticketType === TicketTypeEnum.CashCard && 'cashcard' in ticket && (
                  <Dialog open={cashCardModalOpen} onOpenChange={setCashCardModalOpen}>
                    <DialogContent>
                      <DialogTitle>Cash Card</DialogTitle>
                      <DialogDescription>
                        {ticket.cashcard?.status === 'pending' ? (
                          <div className="flex flex-col items-center gap-2 mt-2">
                            <span className="text-base font-medium text-gray-700 px-2 py-1 rounded text-center">
                              This Cash Card will be available here (at least) a few days before the event starts.
                            </span>
                          </div>
                        ) : (
                          <div className="flex flex-col items-center gap-2 mt-2">
                            <span className="text-lg font-bold text-green-700 bg-green-100 px-3 py-1 rounded">
                              Current Balance: {ticket.cashcard?.balance}
                            </span>
                            <span className="text-base font-medium text-gray-700 bg-gray-100 px-2 py-1 rounded">
                              Initial Balance: {Money.fromInteger(ticket.price.amount, ticket.price.currency).display(lang)}
                            </span>
                          </div>
                        )}
                      </DialogDescription>
                      {ticket.cashcard?.status !== 'pending' && (
                        <div className="flex flex-col items-center gap-4 mt-4">
                          {ticket.cashcard?.qrCode && (
                            <QRCode
                              size={200}
                              className="mx-auto max-w-[180px] p-4 bg-white"
                              level="H"
                              style={{ height: "auto" }}
                              value={ticket.cashcard.qrCode}
                              viewBox={`0 0 256 256`}
                            />
                          )}
                          {ticket.cashcard?.url && (
                            <a
                              href={ticket.cashcard.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center ml-4 bg-[var(--shop-ctaButtonColor)] text-[var(--shop-ctaButtonTextColor)] font-bold p-2 rounded-md text-center hover:opacity-90 transition-all duration-300 hover:shadow-md"
                            >
                              <RiWalletLine className="w-6 h-6" />
                              <span className="ml-2 tracking-tight font-semibold hidden sm:inline">Go to Cash Card</span>
                              <span className="ml-2 tracking-tight font-semibold sm:hidden">Open</span>
                            </a>
                          )}
                        </div>
                      )}
                    </DialogContent>
                  </Dialog>
                )}
              </>
            )}
          </div>
          {/* Bottom Row: Price & Actions */}
          <div className='flex px-4 items-center justify-between grow'>
            {/* CashCard: show balance next to price and Go to Wallet button */}
            {'ticketType' in ticket && ticket.ticketType === TicketTypeEnum.CashCard && 'cashcard' in ticket ? (
              <>
                <span className='text-base leading-normal font-semibold'>
                  {Money.fromInteger(ticket.price.amount, ticket.price.currency).add(Money.fromInteger(ticket.serviceFee.amount, ticket.serviceFee.currency)).display(lang)}
                </span>
                {ticket.cashcard?.url && (
                  <a
                    href={ticket.cashcard.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center ml-4 bg-[var(--shop-ctaButtonColor)] text-[var(--shop-ctaButtonTextColor)] font-bold p-2 rounded-md text-center hover:opacity-90 transition-all duration-300 hover:shadow-md"
                  >
                    <RiWalletLine className="w-6 h-6" />
                    <span className="ml-2 tracking-tight font-semibold hidden sm:inline">Go to Cash Card</span>
                    <span className="ml-2 tracking-tight font-semibold sm:hidden">Open</span>
                  </a>
                )}
              </>
            ) : (
              <>
                <span className='text-base leading-normal font-semibold'>{Money.fromInteger(ticket.price.amount, ticket.price.currency).add(Money.fromInteger(ticket.serviceFee.amount, ticket.serviceFee.currency)).display(lang)}</span>
                <div className='flex itemx-center justify-end gap-4'>
                  {/* Reverted: Check ticketType exists before accessing properties */}
                  {('ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && ticket.ticketType !== TicketTypeEnum.DonationTicket) && (ticket.ticketStatus === TicketStatus.available || ticket.ticketStatus === TicketStatus.claimable) && 'canResell' in ticket && ticket.canResell && (
                    <button
                      onClick={() => setListTicketModalOpen(true)}
                      className='flex items-center hover:underline hover:cursor-pointer hover:bg-[var(--shop-panelBackgroundColor)] rounded-md p-2 -m-2'
                    >
                      <RiCashLine className='w-6 h-6' />
                      <span className='ml-2 tracking-tight font-semibold'>Sell</span>
                  </button>
                  )}
                {/* Reverted: Check ticketType exists before accessing properties */}
                {('ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && ticket.ticketType !== TicketTypeEnum.DonationTicket) && 'ticketMustBePersonalized' in ticket && ticket.ticketMustBePersonalized && (ticket.ticketStatus === TicketStatus.claimable || ticket.ticketStatus === TicketStatus.available) && (
                  <button
                    onClick={() => setShareTicketModalOpen(true)}
                    className='flex items-center hover:underline hover:cursor-pointer hover:bg-[var(--shop-panelBackgroundColor)] rounded-md p-2 -m-2'
                  >
                    <RiShare2Line className='w-6 h-6' />
                    <span className='ml-2 tracking-tight font-semibold'>{m.order_ticket_share()}</span>
                </button>
                )}
                {/* Reverted: Check ticketType exists before accessing properties */}
                {('ticketType' in ticket && ticket.ticketType !== TicketTypeEnum.GroupedTicket && ticket.ticketType !== TicketTypeEnum.DonationTicket) && 'ticketMustBePersonalized' in ticket && !ticket.ticketMustBePersonalized && ticket.ticketStatus === TicketStatus.available && (
                  <ShareTicketWithoutPersonalisationButton ticketId={ticket.ticketId} productName={ticket.productName} />
                )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* Parent Ticket Info Row - Conditionally Rendered only if NOT a sub-ticket */} 
      {ticket.parent && !isSubTicket && 'canResell' in ticket &&!ticket.canResell && (
        <div className="text-xs text-[var(--shop-textColor)] bg-[var(--shop-panelBackgroundColor)] opacity-90 mt-1 p-2 rounded-md flex items-center">
          <RiInformationLine size={14} className="mr-2 flex-shrink-0" /> 
          <span>Part of group ticket: <b>{ticket.parent.parentProductName}</b> (Owner: {ticket.parent.parentTicketHolderName}). This ticket cannot be sold individually; only the main group ticket can be resold.</span>
        </div>
      )}
      {/* Blocked Reason Row - Conditionally Rendered */} 
      {ticket.ticketStatus === TicketStatus.blocked && (
        <div className="text-sm  opacity-90 mt-1 p-2 rounded-md flex items-start bg-red-500 text-white">
          <RiInformationLine size={14} className="mr-2 mt-[1px] flex-shrink-0" /> 
          <div>
            {'blocks' in ticket && Object.entries(ticket.blocks).map(([key, message]) => {
              // Attempt to find a translation using the key
              // @ts-expect-error - Dynamic key access for messages
              const translatedMessage = m.block_reasons?.[key]?.(); 
              return <p key={key} className="mb-1 last:mb-0">{translatedMessage || message}</p>;
            })}
            {/* Fallback if blocks object is not present or empty */} 
            {(!('blocks' in ticket) || Object.keys(ticket.blocks).length === 0) && 'blockedReason' in ticket && (
              <p>{ticket.blockedReason}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Ticket;